import * as React from "react";
import { Button, Modal, Typography, Card, Box, Grid, Divider, Stack, Alert, Tooltip, CircularProgress, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import NumberFormat from "react-number-format";
import { format } from "date-fns";
import ApproveModal from "./ApproveModal";
import RefundActionConfirmationModal from "./RefundActionConfirmationModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getRefundTrxDetails,
  selectPMPaymentState,
  getCancelStatus,
  getCancelOTP,
  selectRefundTrxDetails,
  selectRefundResponseDetails,
  getResetRefundTrxDetails,
  getDenyRefund,
  getCancelRefund,
  getPaymentRequestByTransUuid,
  getExportTransDetails,
  getChargebackDetails,
} from "../sagas/pmTransactionsSlice";
import SpinnerWithNoConfirmation from "../../../shared/Modal/spinnerWithNoConfirmation";
import SpinnerModal from "../../../shared/Modal/SpinnerModal";
import CancelIcon from "../../../icons/close.svg";
import { convertCentsToDollars } from "../../../shared/util/converters";
import PaymentConfirmation from "../../../shared/Modal/PaymentConfirmation";
import { CancelRefundDto, RefundActionResponseDto, TransactionItemDetailsV2Dto, RefundStatusEnum, TransactionTypeEnum, ValidTransactionStatusEnum } from "@inosio/payments-sdk";
import CopyToClipboard from "react-copy-to-clipboard";
import { useHistory } from "react-router-dom";
import copyclipboard from "../../../icons/copyclipboard.svg";
import ExportIcon from "../../../icons/exportIcon2.svg";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ChargebackDetailsModal from "./ChargebackDetailsModal";
import moment from "moment";
import { GetExtendedTransactionStatus } from "../../shared/util/helpers";

const useStyles = makeStyles({
  modalContainer: {
    background: "#FFFFFF",
    boxShadow: "none",
    borderRadius: "24px",
  },
  detailsMainItem: {
    display: "flex",
    flexDirection: "row",
    width: "95%",
    height: "33px",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "1px solid #9999",
    color: "#222",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "17px",
    margin: "0 auto",
  },
  detailsMinorItem: {
    display: "flex",
    flexDirection: "row",
    width: "95%",
    height: "33px",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "1px solid #9999",
    color: "#999",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "17px",
    margin: "0 auto",
  },
  detailsTotal: {
    display: "flex",
    flexDirection: "row",
    width: "95%",
    height: "33px",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "3px solid #222222",
    borderBottom: "3px solid #222222",
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "22px",
    color: "#14142B",
    marginTop: "5px",
    marginBottom: "5px",
    margin: "0 auto",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    position: "absolute",
    bottom: 20,
    width: "30%",
  },
  reviewAndSubmitMainDetails: {
    marginBottom: "18px",
  },
  cancelPaymentBtnStyle: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    borderRadius: "24px",
    borderColor: "#DB3939",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "18px",
    border: "2px solid #DB3939",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "40px",
    width: "150px",
  },
  issueRefundBtnStyle: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    borderRadius: "24px",
    borderColor: "#39A2DB",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "18px",
    border: "2px solid #39A2DB",
    color: "#39A2DB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "40px",
    width: "120px",
  },
  chargebackDetailsBtnStyle: {
    borderRadius: "24px",
    borderColor: "#39A2DB",
    border: "2px solid #39A2DB",
    color: "#39A2DB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "35px",
    width: "200px",
  },
  denyBtnStyle: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    textTransform: "none",
    borderRadius: "24px",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "18px",
    backgroundColor: "#A2DBFA",
    display: "flex",
    alignItems: "center",
    height: "40px",
    width: "120px",
    justifyContent: "center",
  },
  cancelRefundBtnStyle: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    borderRadius: "24px",
    borderColor: "#DB3939",
    height: "38px",
    width: "140px",
    border: "2px solid #DB3939",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "18px",
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
  },
});

interface transactionDetailsProps {
  open: boolean;
  closeCallback: (event: object, reason: string) => void;
  paymentID?: string;
  transactionDate?: string | undefined;
  transactionDateShort?: string;
  deviceWidth?: number;
  refundStatus?: string | undefined | null;
  refreshTransaction?: () => void;
  transactionStatus?: ValidTransactionStatusEnum | undefined;
  refundReceipt: boolean;
  hideDepositBtn?: boolean;
}

export default function TransactionDetails(props: transactionDetailsProps) {
  const classes = useStyles();
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "16px",
    height: "555px",
    pointerEvents: "auto",
    width: "520px",
    borderRadius: "24px",
  };
  const isOnMobileScreen = useMediaQuery("(max-width:600px)");

  const [openApproveModal, setOpenApproveModal] = React.useState(false);
  const [openChargebackDetailsModal, setOpenChargebackDetailsModal] = React.useState(false);
  const [openDenyModal, setOpenDenyModal] = React.useState(false);
  const [openCancelRefundModal, setOpenCancelRefundModal] = React.useState(false);
  const [globalError, setGlobalError] = React.useState<string | null>("");
  const dispatch = useDispatch();

  const { isRefundTrxDetailsFetching, cancelStatusResponse, isCancelOTPError, isCancelOTPSuccess, cancelOTPError, isFetchingPaymentReqByTransUuid, paymentRequestDetails } = useSelector(selectPMPaymentState);
  const { isDenyRefundSuccess, isCancelRefundSuccess, isDenyRefundError, isCancelRefundError, denyRefundError, cancelRefundError, isSuccessChargebackStatusChange } = useSelector(selectPMPaymentState);
  const approveRefundResponse = useSelector(selectRefundResponseDetails);
  const refundTrxDetails = useSelector(selectRefundTrxDetails);
  const [openToolTip, setOpenToolTip] = React.useState(false);
  const history = useHistory();

  let transactionItemDetails: TransactionItemDetailsV2Dto | RefundActionResponseDto;//why would anybody do this???

  if (props.refundReceipt) {
    transactionItemDetails = approveRefundResponse;
  } else {
    transactionItemDetails = refundTrxDetails;
  }

  // check if transaction can be cancelled
  React.useEffect(() => {
    if (props.open) {
      dispatch(getCancelStatus({ transactionUuid: props.paymentID }));
    }
  }, [dispatch, getCancelStatus, props.open]);

  // fetch transaction details
  React.useEffect(() => {
    if (props.open) {
      dispatch(getRefundTrxDetails({ transactionUuid: props.paymentID }));
    }
  }, [dispatch, getRefundTrxDetails, props.open, isSuccessChargebackStatusChange]);

  const handleCloseCancelOTPSpinnerModal = React.useCallback(() => {
    setIsCancelOTPSpinnerModalOpen(false);
  }, []);

  const [isCancelOTPSpinnerModalOpen, setIsCancelOTPSpinnerModalOpen] = React.useState(false);
  const [globalCancelOTPError, setGlobalCancelOTPError] = React.useState<string | null>(null);
  const [cancelOTPSpinnerStatus, setCancelOTPSpinnerStatus] = React.useState<string | null>(null);
  const [openConfirmation, setOpenConfirmation] = React.useState(false);
  const handleOpenConfirmation = () => setOpenConfirmation(true);
  const [value, setValue] = React.useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleCloseConfirmation = () => setOpenConfirmation(false);

  const onCloseClick = () => {
    props.closeCallback({}, "closeDetailsModal");
    dispatch({
      type: getResetRefundTrxDetails.type,
    });
  };

  React.useEffect(() => {
    if (isCancelOTPSuccess) {
      setCancelOTPSpinnerStatus("stop");
    }
  }, [isCancelOTPSuccess]);

  React.useEffect(() => {
    if (isCancelOTPError) {
      handleCloseCancelOTPSpinnerModal();
      setGlobalCancelOTPError(cancelOTPError);
      console.log(globalCancelOTPError);
    }
  }, [isCancelOTPError, cancelOTPError, setGlobalCancelOTPError, handleCloseCancelOTPSpinnerModal]);

  // reset error states everytime a new transaction is in scope
  React.useEffect(() => {
    setGlobalError(null);
    setGlobalCancelOTPError(null);
  }, [props.paymentID]);

  const handleCancelPaymentClick = () => {
    dispatch(getCancelOTP({ transactionUuid: props.paymentID }));
    setIsCancelOTPSpinnerModalOpen(true);
  };

  React.useEffect(() => {
    if (transactionItemDetails?.TransactionType === TransactionTypeEnum.PaymentRequest) {
      dispatch({
        type: getPaymentRequestByTransUuid.type,
        payload: props.paymentID,
      });
    }
  }, [dispatch, transactionItemDetails?.TransactionType]);

  const handleDenyPaymentClick = (transactionUuid: string, message: string) => {
    dispatch(getDenyRefund({ transactionUuid, message }));
    props.closeCallback({}, "close Trx Details Modal");
  };


  const handleCancelRefundClick = (transactionUuid: string, message: string) => {
    dispatch({
      type: getCancelRefund.type,
      transactionUUid: transactionUuid,
      payload: {
        message,
      } as CancelRefundDto,
    });
    props.closeCallback({}, "close Trx Details Modal");
  };

  return (
    <div className={`${classes.modalContainer}`}>
      <Modal
        open={props.open}
        onClose={onCloseClick}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        BackdropProps={{
          invisible: false,
        }}
      >
        <Card sx={style}>
          {/* Cancel OTP Spinner */}
          {isCancelOTPSpinnerModalOpen ? (
            <SpinnerModal height={isOnMobileScreen ? "100%" : "700px"} openSpinnerModal={isCancelOTPSpinnerModalOpen} handleCloseSpinnerModal={handleCloseCancelOTPSpinnerModal} spinnerStatus={cancelOTPSpinnerStatus} closeCancel={onCloseClick} />
          ) : (
            <></>
          )}
          {/* details fetching spinner */}
          {isRefundTrxDetailsFetching ? (
            <Grid item xs={12}>
              <Stack direction="column" justifyContent="center" alignItems="center" style={{ height: "50vh" }}>
                <SpinnerWithNoConfirmation />
              </Stack>
            </Grid>
          ) : (
              <>
                <Grid container>
                  <Grid item xs={8}>
                    {globalError && <Alert severity="error">{globalError}</Alert>}
                  </Grid>
                </Grid>
                <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
                  <Typography
                    sx={{
                      mt: 2,
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontFamily: "Work Sans",
                    }}
                  >
                    Payment ID: {transactionItemDetails.TransactionUuid}
                  </Typography>
                  <Grid item mt={2} ml={1}>
                    <CopyToClipboard text={transactionItemDetails.TransactionUuid!}>
                      <Tooltip title={"Copied"} open={openToolTip} onClose={() => setOpenToolTip(false)} onClick={() => setOpenToolTip(true)} sx={{ cursor: "pointer" }} placement="top">
                        <img src={copyclipboard} alt="copy" style={{ cursor: "pointer" }} />
                      </Tooltip>
                    </CopyToClipboard>
                  </Grid>
                </Grid>
                <Grid item xs={12} display="flex" justifyContent="center">
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontFamily: "Work Sans",
                      color: "#999999",
                      align: "center",
                    }}
                  >
                    {transactionItemDetails?.TransactionDate && format(new Date(transactionItemDetails?.TransactionDate), "EEEE, MMMM d, yyyy hh:mm a")}
                    {/* {moment(new Date(transactionItemDetails?.TransactionDate!)).format("LLLL")} */}
                  </Typography>
                </Grid>
                <Grid item xs={12} display="flex" justifyContent="center">
                  <Typography
                    align="center"
                    sx={{
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "22px",
                      fontFamily: "Work Sans",
                      marginTop: 0.5,
                      marginBottom: 0.5,
                    }}
                  >
                    {GetExtendedTransactionStatus(transactionItemDetails)}
                  </Typography>
                </Grid>
                <Box sx={{ width: "100%" }}>
                  <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                    <Grid item xs={7}>
                      <Typography
                        style={{
                          color: "#14142B",
                          fontSize: "16px",
                        }}
                        id="review-submit-main-details"
                      >
                        {transactionItemDetails.CompanyName}
                      </Typography>
                    </Grid>
                    <Grid item xs={5}>
                      <Typography
                        style={{
                          color: "#14142B",
                          fontSize: "16px",
                        }}
                        id="review-submit-main-details"
                      >
                        {transactionItemDetails.PayeeName}
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <div className={classes.reviewAndSubmitMainDetails}>
                        <Typography
                          style={{
                            color: "#14142B",
                            fontSize: "16px",
                          }}
                          id="review-submit-main-details"
                        >
                          {transactionItemDetails.PayerName}
                        </Typography>
                      </div>
                    </Grid>
                    {transactionItemDetails.PropertyNamePlaceholder ? (
                      <Grid item xs={5}>
                        <div className={classes.reviewAndSubmitMainDetails}>
                          <Typography
                            style={{
                              color: "#14142B",
                              fontSize: "16px",
                            }}
                            id="review-submit-main-details"
                          >
                            {transactionItemDetails.PropertyNamePlaceholder}
                          </Typography>
                        </div>
                      </Grid>
                    ) : (
                      <></>
                    )}
                   
                  </Grid>
                  <Divider />
                  {transactionItemDetails.TransactionType === TransactionTypeEnum.PaymentRequest ? (
                    <TabContext value={value}>
                      <Grid item display="flex" justifyContent="center">
                        <Box>
                          <TabList onChange={handleChange}>
                            <Tab label="Summary" value="1" style={{ marginRight: "70px", textTransform: "none" }} />
                            <Tab label="Request Details" value="2" style={{ textTransform: "none" }} />
                          </TabList>
                        </Box>
                      </Grid>
                      <Box>
                        <TabPanel value="1">
                          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={7}>
                              <Typography id="review-submit-bank-details-text"> Payment Method</Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography id="review-submit-sub-bank-details-color-grey">{transactionItemDetails?.PayMethodLastFour}</Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography id="review-submit-sub-details">Leaseholder Name</Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography id="review-submit-sub-details">{transactionItemDetails.PayerName}</Typography>
                            </Grid>
                            {
                              transactionItemDetails?.PayFields?.map((payfield, index) => {
                                if (payfield.Amount === 0) return null;
                                return (
                                  <React.Fragment key={index}>
                                    <Grid item xs={7}>
                                      <Typography id="review-submit-sub-details">{payfield.Description}</Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                      <Typography id="review-submit-sub-details">
                                        <NumberFormat
                                          thousandsGroupStyle="thousand"
                                          value={convertCentsToDollars(payfield.Amount)}
                                          prefix="$"
                                          decimalSeparator="."
                                          displayType="text"
                                          type="text"
                                          thousandSeparator={true}
                                          allowNegative={true}
                                          decimalScale={2}
                                          fixedDecimalScale={true}
                                        />
                                      </Typography>
                                    </Grid>
                                  </React.Fragment>
                                );
                              })}
                            <Grid item xs={7}>
                              <Typography id="review-submit-sub-details">Fee Amount</Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography id="review-submit-sub-details">
                                <NumberFormat
                                  thousandsGroupStyle="thousand"
                                  value={convertCentsToDollars(transactionItemDetails?.Fees || 0)}
                                  prefix="$"
                                  decimalSeparator="."
                                  displayType="text"
                                  type="text"
                                  thousandSeparator={true}
                                  allowNegative={true}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                />
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography id="review-submit-sub-details">Total Amount</Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography id="review-submit-sub-details">
                                <NumberFormat
                                  thousandsGroupStyle="thousand"
                                  value={convertCentsToDollars((transactionItemDetails?.Amount || 0) + (transactionItemDetails?.Fees || 0))}
                                  prefix="$"
                                  decimalSeparator="."
                                  displayType="text"
                                  type="text"
                                  thousandSeparator={true}
                                  allowNegative={true}
                                  decimalScale={2}
                                  fixedDecimalScale={true}
                                />
                              </Typography>
                            </Grid>
                            <Grid item xs={7}>
                              <Typography id="review-submit-sub-details">Transaction Date</Typography>
                            </Grid>
                            <Grid item xs={5}>
                              <Typography id="review-submit-sub-details">{format(new Date(transactionItemDetails.TransactionDate!), "MM/dd/yyyy")}</Typography>
                            </Grid>
                          </Grid>
                        </TabPanel>
                      </Box>
                      <TabPanel value="2">
                        {isFetchingPaymentReqByTransUuid ? (
                          <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }} mt={2}>
                            <CircularProgress size={40} />
                          </Grid>
                        ) : (
                          <Grid
                            item
                            xs={12}
                            sx={{
                              maxHeight: "180px",
                              overflow: "auto",
                              "&::-webkit-scrollbar": {
                                width: 7,
                              },
                              "&::-webkit-scrollbar-track": {
                                boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
                                borderRadius: "24px",
                              },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "darkgrey",
                                borderRadius: "24px",
                              },
                            }}
                          >
                            {paymentRequestDetails?.RequestDetails?.map((req, index) => {
                              return (
                                <Grid item xs={12} key={index}>
                                  <Grid item xs={12} display="flex" justifyContent={"space-between"} ml={1} mr={2}>
                                    <Grid item xs={9.5}>
                                      <Typography
                                        sx={{
                                          fontWeight: 600,
                                          fontSize: "16px",
                                          lineHeight: "22px",
                                          fontFamily: "Work Sans",
                                          color: "#D3D3D3",
                                        }}
                                      >
                                        {req.Description}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={2.5}>
                                      <Typography
                                        sx={{
                                          fontWeight: 400,
                                          fontSize: "16px",
                                          lineHeight: "22px",
                                          fontFamily: "Work Sans",
                                          color: "#D3D3D3",
                                        }}
                                      >
                                        <NumberFormat
                                          thousandsGroupStyle="thousand"
                                          value={convertCentsToDollars(req.Amount)}
                                          prefix="$"
                                          decimalSeparator="."
                                          displayType="text"
                                          type="text"
                                          thousandSeparator={true}
                                          allowNegative={true}
                                          decimalScale={2}
                                          fixedDecimalScale={true}
                                        />
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12} mt={1} mb={1} mr={1}>
                                    {<Divider sx={{ width: "100%" }} />}
                                  </Grid>
                                </Grid>
                              );
                            })}
                          </Grid>
                        )}
                      </TabPanel>
                    </TabContext>
                  ) : (
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                      <Grid item xs={7}>
                        <Typography id="review-submit-bank-details-text"> Payment Method</Typography>
                      </Grid>
                      <Grid item xs={5}>
                        <Typography id="review-submit-sub-bank-details-color-grey">{transactionItemDetails?.PayMethodLastFour}</Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography id="review-submit-sub-details">Leaseholder Name</Typography>
                      </Grid>
                      <Grid item xs={5}>
                        <Typography id="review-submit-sub-details">{transactionItemDetails.PayerName}</Typography>
                      </Grid>
                      {
                        transactionItemDetails?.PayFields?.map((payfield, index) => {
                          if (payfield.Amount === 0) return null;
                          return (
                            <React.Fragment key={index}>
                              <Grid item xs={7}>
                                <Typography id="review-submit-sub-details">{payfield.Description}</Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography id="review-submit-sub-details">
                                  <NumberFormat
                                    thousandsGroupStyle="thousand"
                                    value={convertCentsToDollars(payfield.Amount)}
                                    prefix="$"
                                    decimalSeparator="."
                                    displayType="text"
                                    type="text"
                                    thousandSeparator={true}
                                    allowNegative={true}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  />
                                </Typography>
                              </Grid>
                            </React.Fragment>
                          );
                        })}
                      <Grid item xs={7}>
                        <Typography id="review-submit-sub-details">Fee Amount</Typography>
                      </Grid>
                      <Grid item xs={5}>
                        <Typography id="review-submit-sub-details">
                          <NumberFormat
                            thousandsGroupStyle="thousand"
                            value={convertCentsToDollars(transactionItemDetails?.Fees || 0)}
                            prefix="$"
                            decimalSeparator="."
                            displayType="text"
                            type="text"
                            thousandSeparator={true}
                            allowNegative={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography id="review-submit-sub-details">Total Amount</Typography>
                      </Grid>
                      <Grid item xs={5}>
                        <Typography id="review-submit-sub-details">
                          <NumberFormat
                            thousandsGroupStyle="thousand"
                            value={convertCentsToDollars((transactionItemDetails?.Amount || 0) +( transactionItemDetails?.Fees || 0))}
                            prefix="$"
                            decimalSeparator="."
                            displayType="text"
                            type="text"
                            thousandSeparator={true}
                            allowNegative={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </Typography>
                      </Grid>
                      <Grid item xs={7}>
                        <Typography id="review-submit-sub-details">Transaction Date</Typography>
                      </Grid>
                      <Grid item xs={5}>
                        <Typography id="review-submit-sub-details">{moment(transactionItemDetails?.TransactionDate!).format("MM/DD/yyyy")}</Typography>
                      </Grid>
                    </Grid>
                  )}
                  <Grid container>
                    {!props.refundReceipt ? (
                      cancelStatusResponse && transactionItemDetails.Status === ValidTransactionStatusEnum.Pending ? (
                        <Grid item xs={8}>
                          <div className={classes.buttonContainer}>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <div className={classes.cancelPaymentBtnStyle}>
                                  <Button style={{ textTransform: "none", color: "#DB3939" }} onClick={handleOpenConfirmation}>
                                    Cancel Payment
                                  </Button>
                                </div>
                              </Grid>
                              <Grid item xs={6}></Grid>
                            </Grid>
                          </div>
                        </Grid>
                      ) : (
                        <Grid item xs={8}>
                          <div className={classes.buttonContainer}>
                            {
                              <Grid container spacing={1}>
                                {transactionItemDetails.Status === ValidTransactionStatusEnum.Chargedback && (
                                  <Grid item>
                                    <div
                                      className={classes.chargebackDetailsBtnStyle}
                                      onClick={() => {
                                        setOpenChargebackDetailsModal(true);
                                        dispatch({
                                          type: getChargebackDetails.type,
                                          payload: props.paymentID,
                                        });
                                      }}
                                    >
                                      <Button
                                        style={{
                                          textTransform: "none",
                                          color: "#39A2DB",
                                          fontWeight: 700,
                                          fontSize: "13px",
                                          fontFamily: "'Open Sans', sans-serif",
                                          fontStyle: "normal",
                                        }}
                                      >
                                        View Chargeback Details
                                      </Button>
                                    </div>
                                  </Grid>
                                )}
                                {transactionItemDetails.Status === ValidTransactionStatusEnum.Completed &&
                                (transactionItemDetails?.RefundDetails?.Status === RefundStatusEnum.Denied || null || RefundStatusEnum.Requested) &&
                                !(transactionItemDetails?.RefundDetails?.Status === RefundStatusEnum.Approved) ? (
                                  <Grid item>
                                    <div
                                      className={classes.issueRefundBtnStyle}
                                      onClick={() => {
                                        setOpenApproveModal(true);
                                      }}
                                    >
                                      <Button style={{ textTransform: "none" }}>Issue Refund</Button>
                                    </div>
                                  </Grid>
                                ) : (
                                  <></>
                                )}
                                {transactionItemDetails.Status === ValidTransactionStatusEnum.Completed && transactionItemDetails?.RefundDetails?.Status === RefundStatusEnum.Requested ? (
                                  <Grid item>
                                    <div className={classes.denyBtnStyle}>
                                      <Button
                                        style={{
                                          textTransform: "none",
                                          color: "#FFFFFF",
                                        }}
                                        onClick={() => {
                                          setOpenDenyModal(true);
                                        }}
                                      >
                                        Deny Refund
                                      </Button>
                                    </div>
                                  </Grid>
                                ) : (
                                  <>
                                    {transactionItemDetails.Status === ValidTransactionStatusEnum.Completed && transactionItemDetails?.RefundDetails?.Status === RefundStatusEnum.Approved ? (
                                      <Grid item>
                                        <div className={classes.cancelRefundBtnStyle}>
                                          <Button
                                            style={{
                                              textTransform: "none",
                                              color: "#DB3939",
                                            }}
                                            onClick={() => {
                                              setOpenCancelRefundModal(true);
                                            }}
                                          >
                                            Cancel Refund
                                          </Button>
                                        </div>
                                      </Grid>
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                )}
                              </Grid>
                            }
                          </div>
                        </Grid>
                      )
                    ) : (
                      <></>
                    )}
                    <Grid item xs={props.refundReceipt ? 12 : 4} sx={props.refundReceipt ? { display: "flex", justifyContent: "flex-end" } : {}}>
                      <div className={classes.buttonContainer}>
                        {transactionItemDetails.Status === ValidTransactionStatusEnum.Pending ? (
                          ""
                        ) : (
                          <Button
                            variant="contained"
                            style={{
                              textTransform: "none",
                              fontFamily: "'Open Sans', sans-serif",
                              fontStyle: "normal",
                              fontWeight: 700,
                              backgroundColor: "#39A2DB",
                              borderRadius: "24px",
                            }}
                            onClick={() => {
                              history.push(`deposits?transactionuuid=${transactionItemDetails?.TransactionUuid}`);
                            }}
                          >
                            View Deposit
                          </Button>
                        )}
                      </div>
                    </Grid>
                  </Grid>
                  <Grid item sx={{ position: "absolute", top: 18, right: 20 }}>
                    <img
                      src={CancelIcon}
                      alt="close"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        onCloseClick();
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    sx={{
                      position: "absolute",
                      bottom: transactionItemDetails.TransactionType === TransactionTypeEnum.PaymentRequest && value === "1" ? 75 : transactionItemDetails.TransactionType === TransactionTypeEnum.PaymentRequest && value === "2" ? 75 : 120,
                      left: transactionItemDetails.TransactionType === TransactionTypeEnum.PaymentRequest && value === "1" ? 35 : transactionItemDetails.TransactionType === TransactionTypeEnum.PaymentRequest && value === "2" ? 35 : 15,
                    }}
                  >
                    <img
                      src={ExportIcon}
                      alt="close"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        dispatch({
                          type: getExportTransDetails.type,
                          payload: props.paymentID,
                        });
                      }}
                    />
                  </Grid>
                </Box>
              </>
            )
          }
        </Card>
      </Modal>
      <ApproveModal
        open={openApproveModal}
        closeCallback={(event: object, reason: string) => {
          setOpenApproveModal(false);
          props.refreshTransaction?.();
        }}
        closeBaseModal={(event: object, reason: string) => {
          props.closeCallback(event, reason);
        }}
        amount={convertCentsToDollars(transactionItemDetails?.Amount!)}
        residentName={transactionItemDetails.PayerName!}
        transactionUuid={transactionItemDetails?.TransactionUuid!}
        refundStatus={props.refundStatus!}
        globalError={globalError}
        setGlobalError={setGlobalError}
      />

      {/* deny refund requests */}
      <RefundActionConfirmationModal
        open={openDenyModal}
        closeCallback={(event: object, reason: string) => {
          setOpenDenyModal(false);
          props.refreshTransaction?.();
        }}
        closeBaseModal={(event: object, reason: string) => {
          props.closeCallback(event, reason);
        }}
        isActionSuccess={isDenyRefundSuccess}
        isActionError={isDenyRefundError}
        actionError={denyRefundError}
        transactionDate={transactionItemDetails?.TransactionDate!}
        leaseHolderName={transactionItemDetails.PayerName!}
        paymentID={transactionItemDetails?.TransactionUuid!}
        pmCompany={transactionItemDetails.CompanyName ?? ''}
        properyName={transactionItemDetails.PayeeName ?? ''}
        unitName={''}
        handleConfirmationButtonClicked={handleDenyPaymentClick}
        setGlobalError={setGlobalError}
        actionMessage={"Deny Refund"}

      />

      {/* cancel pre-approved refunds that have not been processed */}
      <RefundActionConfirmationModal
        open={openCancelRefundModal}
        closeCallback={(event: object, reason: string) => {
          setOpenCancelRefundModal(false);
          props.refreshTransaction?.();
        }}
        closeBaseModal={(event: object, reason: string) => {
          props.closeCallback(event, reason);
        }}
        isActionSuccess={isCancelRefundSuccess}
        isActionError={isCancelRefundError}
        actionError={cancelRefundError}
        transactionDate={transactionItemDetails?.TransactionDate!}
        leaseHolderName={transactionItemDetails.PayerName!}
        paymentID={transactionItemDetails?.TransactionUuid!}
        handleConfirmationButtonClicked={handleCancelRefundClick}
        setGlobalError={setGlobalError}
        actionMessage={"Cancel Refund"}
        pmCompany={transactionItemDetails.CompanyName ?? ''}
        properyName={transactionItemDetails.PayeeName ?? ''}
        unitName={''}
      />

      {openConfirmation ? <PaymentConfirmation open={openConfirmation} onClose={handleCloseConfirmation} cancelTransaction={handleCancelPaymentClick} /> : <></>}

      {/**Chargeback Details */}
      <ChargebackDetailsModal
        open={openChargebackDetailsModal}
        paymentID={props.paymentID ?? ""}
        onClose={() => {
          setOpenChargebackDetailsModal(false);
        }}
        chargebackStatus={transactionItemDetails.Status}
      />
    </div>
  );
}
